const tipoDiagnostico = {
  boolean: 1,
  texto: 2,
  arquivo: 3,
  data: 4,
  telefone: 5,
  email: 6,
  horaMin: 7,
  video: 8,
  cep: 9,
  numero: 10,
  textArea: 11,
  lista115: 12,
  intervalo: 13,
  multiplasEscolhas: 14,
  intervaloDuplo: 15,
  link: 16,
};

export default tipoDiagnostico;
